// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import {
//   useAuthState,
//   useSignInWithGoogle,
// } from "react-firebase-hooks/auth";
// import auth from "../firebase.init";
// import Loading from "../components/Shared/Loading";

// const getErrorMessage = (errorCode) => {
//   switch (errorCode) {
//     case "auth/popup-closed-by-user":
//       return "Sign-in popup closed by user.";
//     case "auth/popup-blocked":
//       return "Sign-in popup was blocked. Please allow popups for this site.";
//     case "auth/cancelled-popup-request":
//       return "Sign-in cancelled. Please try again.";
//     case "auth/network-request-failed":
//       return "Network error. Please check your connection and try again.";
//     case "auth/user-not-found":
//       return "No account found with this Google account.";
//     case "auth/account-exists-with-different-credential":
//       return "An account already exists with a different sign-in method.";
//     default:
//       return "An error occurred during sign in. Please try again.";
//   }
// };

// const Login = () => {
//   const [signInWithGoogle, gUser, gLoading, gError] = useSignInWithGoogle(auth);
//   const [apiError, setApiError] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [userMail] = useAuthState(auth);

//   useEffect(() => {
//     if (userMail) {
//       navigate("/user/dashboard", { replace: true });
//     }
//   }, [userMail, navigate]);

//   let from = location.state?.from?.pathname || "/user/dashboard";
//   let signInError;

//   useEffect(() => {
//     if (gError || apiError) {
//       window.scrollTo(0, 0);
//     }
//   }, [gError, apiError]);

//   useEffect(() => {
//     if (gUser || userMail) {
//       setIsProcessing(true);
//       setTimeout(() => {
//         navigate(from, { replace: true });
//       }, 500);
//     }
//   }, [gUser, userMail, from, navigate]);

//   if (gLoading || isProcessing) {
//     return <Loading />;
//   }

//   if (gError || apiError) {
//     const errorCode = gError?.code;
//     signInError = (
//       <div className="error-message">
//         <i className="fas fa-exclamation-circle"></i>
//         <p>{apiError || getErrorMessage(errorCode)}</p>
//       </div>
//     );
//   }

//   const handleGoogleSignIn = () => {
//     setApiError(null);
//     signInWithGoogle();
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Login - Welcome Back</title>
//         <meta
//           name="description"
//           content="Discover proven strategies and tools to instantly find high-quality SEO clients. Learn how to attract, pitch, and close deals faster to grow your digital marketing business."
//         />
//       </Helmet>

//       <section className="modern-login-page">
//         <div className="login-container">
//           <div className="login-card">
//             <div className="login-header">
//               <div className="close-button">
//                 <Link to="/" className="close-link">
//                   <i className="fas fa-times"></i>
//                 </Link>
//               </div>

//               <div className="logo-section">
//                 <Link to="/">
//                   <img
//                     src="images/resource/login-page-logo.png"
//                     alt="Logo"
//                     className="logo"
//                   />
//                 </Link>
//               </div>

//               <div className="welcome-section">
//                 <h1>Welcome Back</h1>
//                 <p>Sign in to continue to your account</p>
//               </div>
//             </div>

//             <div className="login-content">
//               {signInError}

//               <div className="google-signin-section">
//                 <button
//                   onClick={handleGoogleSignIn}
//                   className="google-signin-btn"
//                   disabled={gLoading || isProcessing}
//                 >
//                   <div className="google-icon">
//                     <svg width="20" height="20" viewBox="0 0 20 20">
//                       <path d="M19.8 10.2c0-.6-.1-1.2-.2-1.8H10v3.4h5.5c-.2 1.2-.9 2.3-1.9 3v2.5h3.1c1.8-1.7 2.8-4.1 2.8-7.1z" fill="#4285f4"/>
//                       <path d="M10 20c2.6 0 4.8-.9 6.4-2.4l-3.1-2.5c-.9.6-2 1-3.3 1-2.5 0-4.7-1.7-5.5-4H1.4v2.5C3 17.4 6.3 20 10 20z" fill="#34a853"/>
//                       <path d="M4.5 11.9c-.2-.6-.3-1.2-.3-1.9s.1-1.3.3-1.9V5.6H1.4C.5 7.3 0 8.6 0 10s.5 2.7 1.4 4.4l3.1-2.5z" fill="#fbbc05"/>
//                       <path d="M10 4c1.4 0 2.7.5 3.7 1.4L16.6 2.5C14.8 1 12.6 0 10 0 6.3 0 3 2.6 1.4 5.6l3.1 2.5C5.3 5.7 7.5 4 10 4z" fill="#ea4335"/>
//                     </svg>
//                   </div>
//                   <span>Continue with Google</span>
//                 </button>
//               </div>

//               <div className="benefits-section">
//                 <h3>Your Account Benefits</h3>
//                 <div className="benefits-list">
//                   <div className="benefit-item">
//                     <i className="fas fa-check-circle"></i>
//                     <span>Access to all premium features</span>
//                   </div>
//                   <div className="benefit-item">
//                     <i className="fas fa-check-circle"></i>
//                     <span>Personalized dashboard</span>
//                   </div>
//                   <div className="benefit-item">
//                     <i className="fas fa-check-circle"></i>
//                     <span>Save your preferences</span>
//                   </div>
//                   <div className="benefit-item">
//                     <i className="fas fa-check-circle"></i>
//                     <span>Track your progress</span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="login-footer">
//               <p>Don't have an account? <Link to="/register" className="register-link">Sign up for free</Link></p>
//               <div className="help-section">
//                 {/* <p>Need help? <a href="/support">Contact Support</a></p> */}
//               </div>
//             </div>
//           </div>
//         </div>

//         <style jsx>{`
//           .modern-login-page {
//             min-height: 100vh;
//             background-image: url(images/shapes/login-page-shape-1.png);
//             background-size: cover;
//             background-position: center;
//             background-repeat: no-repeat;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             padding: 20px;
//             position: relative;
//             overflow: hidden;
//           }

//           .modern-login-page::before {
//             content: '';
//             position: absolute;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(0, 0, 0, 0.3);
//             backdrop-filter: blur(1px);
//           }

//           .login-container {
//             position: relative;
//             z-index: 1;
//             width: 100%;
//             max-width: 480px;
//           }

//           .login-card {
//             background: rgba(255, 255, 255, 0.95);
//             backdrop-filter: blur(10px);
//             border-radius: 20px;
//             box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
//             overflow: hidden;
//             border: 1px solid rgba(255, 255, 255, 0.2);
//             animation: slideUp 0.6s ease-out;
//           }

//           @keyframes slideUp {
//             from {
//               opacity: 0;
//               transform: translateY(30px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           .login-header {
//             padding: 40px 40px 30px;
//             text-align: center;
//             position: relative;
//           }

//           .close-button {
//             position: absolute;
//             top: 20px;
//             right: 20px;
//           }

//           .close-link {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             width: 40px;
//             height: 40px;
//             background: rgba(0, 0, 0, 0.1);
//             border-radius: 50%;
//             color: #666;
//             text-decoration: none;
//             transition: all 0.3s ease;
//           }

//           .close-link:hover {
//             background: rgba(0, 0, 0, 0.2);
//             color: #333;
//             transform: rotate(90deg);
//           }

//           .logo-section {
//             margin-bottom: 30px;
//           }

//           .logo {
//             height: 60px;
//             width: auto;
//           }

//           .welcome-section h1 {
//             font-size: 28px;
//             font-weight: 700;
//             color: #333;
//             margin-bottom: 10px;
//           }

//           .welcome-section p {
//             font-size: 16px;
//             color: #666;
//             margin: 0;
//           }

//           .login-content {
//             padding: 0 40px 30px;
//           }

//           .error-message {
//             background: #fee;
//             border: 1px solid #fcc;
//             border-radius: 12px;
//             padding: 15px;
//             margin-bottom: 25px;
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             animation: shake 0.5s ease-in-out;
//           }

//           @keyframes shake {
//             0%, 100% { transform: translateX(0); }
//             25% { transform: translateX(-5px); }
//             75% { transform: translateX(5px); }
//           }

//           .error-message i {
//             color: #d32f2f;
//             font-size: 18px;
//           }

//           .error-message p {
//             color: #d32f2f;
//             margin: 0;
//             font-size: 14px;
//           }

//           .google-signin-section {
//             margin-bottom: 30px;
//           }

//           .google-signin-btn {
//             width: 100%;
//             height: 56px;
//             background: #fff;
//             border: 2px solid #e0e0e0;
//             border-radius: 12px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             gap: 12px;
//             font-size: 16px;
//             font-weight: 500;
//             color: #333;
//             cursor: pointer;
//             transition: all 0.3s ease;
//             position: relative;
//             overflow: hidden;
//           }

//           .google-signin-btn::before {
//             content: '';
//             position: absolute;
//             top: 0;
//             left: -100%;
//             width: 100%;
//             height: 100%;
//             background: linear-gradient(90deg, transparent, rgba(66, 133, 244, 0.1), transparent);
//             transition: left 0.6s ease;
//           }

//           .google-signin-btn:hover::before {
//             left: 100%;
//           }

//           .google-signin-btn:hover {
//             border-color: #4285f4;
//             box-shadow: 0 4px 12px rgba(66, 133, 244, 0.2);
//             transform: translateY(-2px);
//           }

//           .google-signin-btn:active {
//             transform: translateY(0);
//           }

//           .google-signin-btn:disabled {
//             opacity: 0.7;
//             cursor: not-allowed;
//             transform: none;
//           }

//           .google-icon {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 1;
//           }

//           .google-signin-btn span {
//             z-index: 1;
//           }

//           .benefits-section {
//             text-align: center;
//           }

//           .benefits-section h3 {
//             font-size: 20px;
//             font-weight: 600;
//             color: #333;
//             margin-bottom: 20px;
//           }

//           .benefits-list {
//             display: flex;
//             flex-direction: column;
//             gap: 12px;
//           }

//           .benefit-item {
//             display: flex;
//             align-items: center;
//             gap: 12px;
//             padding: 12px 16px;
//             background: rgba(76, 175, 80, 0.1);
//             border-radius: 8px;
//             font-size: 14px;
//             color: #555;
//             text-align: left;
//             transition: all 0.3s ease;
//           }

//           .benefit-item:hover {
//             background: rgba(76, 175, 80, 0.15);
//             transform: translateX(5px);
//           }

//           .benefit-item i {
//             color: #4caf50;
//             font-size: 16px;
//             flex-shrink: 0;
//           }

//           .login-footer {
//             padding: 30px 40px;
//             background: rgba(0, 0, 0, 0.02);
//             text-align: center;
//             border-top: 1px solid rgba(0, 0, 0, 0.05);
//           }

//           .login-footer p {
//             margin: 0 0 15px;
//             color: #666;
//             font-size: 14px;
//           }

//           .register-link {
//             color: #4285f4;
//             text-decoration: none;
//             font-weight: 500;
//             transition: color 0.3s ease;
//           }

//           .register-link:hover {
//             color: #3367d6;
//             text-decoration: underline;
//           }

//           .help-section p {
//             font-size: 12px;
//             color: #999;
//             margin: 0;
//           }

//           .help-section a {
//             color: #4285f4;
//             text-decoration: none;
//             transition: color 0.3s ease;
//           }

//           .help-section a:hover {
//             color: #3367d6;
//             text-decoration: underline;
//           }

//           @media (max-width: 768px) {
//             .modern-login-page {
//               padding: 10px;
//             }

//             .login-header {
//               padding: 30px 30px 20px;
//             }

//             .login-content {
//               padding: 0 30px 20px;
//             }

//             .login-footer {
//               padding: 20px 30px;
//             }

//             .welcome-section h1 {
//               font-size: 24px;
//             }
//           }

//           @media (max-width: 480px) {
//             .login-header {
//               padding: 20px 20px 15px;
//             }

//             .login-content {
//               padding: 0 20px 15px;
//             }

//             .login-footer {
//               padding: 15px 20px;
//             }

//             .welcome-section h1 {
//               font-size: 22px;
//             }

//             .welcome-section p {
//               font-size: 14px;
//             }

//             .google-signin-btn {
//               height: 50px;
//               font-size: 14px;
//             }

//             .benefits-section h3 {
//               font-size: 18px;
//             }

//             .benefit-item {
//               font-size: 13px;
//             }
//           }
//         `}</style>
//       </section>
//     </>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuthState, useSignInWithGoogle, useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import auth from "../firebase.init";
import Loading from "../components/Shared/Loading";

const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case "auth/popup-closed-by-user":
      return "Sign-in popup closed by user.";
    case "auth/popup-blocked":
      return "Sign-in popup was blocked. Please allow popups for this site.";
    case "auth/cancelled-popup-request":
      return "Sign-in cancelled. Please try again.";
    case "auth/network-request-failed":
      return "Network error. Please check your connection and try again.";
    default:
      return "An error occurred during registration. Please try again.";
  }
};

const Login = () => {
  const [signInWithGoogle, gUser, gLoading, gError] = useSignInWithGoogle(auth);
  const [signInWithEmailAndPassword, eUser, eLoading, eError] = useSignInWithEmailAndPassword(auth);
  const [apiError, setApiError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [userMail] = useAuthState(auth);

  useEffect(() => {
    if (userMail) {
      navigate("/", { replace: true });
    }
  }, [userMail, navigate]);

  let from = location.state?.from?.pathname || "/";
  let signUpError;

  useEffect(() => {
    if (gError || apiError) {
      window.scrollTo(0, 0);
    }
  }, [gError, apiError]);

  // Create user in database after successful Firebase authentication
  const createUserInDb = async (name, email, photoURL) => {
    try {
      const response = await fetch(`https://demo-email-marketing-1-f6e91377e127.herokuapp.com/api/create-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: name,
          userEmail: email,
          profileURL: photoURL || null,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.error === "User already exists") {
          return data;
        }
        throw new Error(data.error || "Failed to create user");
      }

      console.log("User created with credits:", data);
      return data;
    } catch (err) {
      console.error("Error creating user in database:", err);
      setApiError(err.message);
      return null;
    }
  };

  useEffect(() => {
    const handleUserCreation = async () => {
      if (gUser || eUser) {
        setIsProcessing(true);
        const user = auth.currentUser;
        if (user) {
          const { displayName, email, photoURL } = user;
          await createUserInDb(displayName || "Demo User", email, photoURL);
        }
        setIsProcessing(false);
        navigate(from, { replace: true });
      }
    };

    handleUserCreation();
  }, [gUser, eUser, from, navigate]);

  if (gLoading || eLoading || isProcessing) {
    return <Loading />;
  }

  if (gError || eError || apiError) {
    const errorCode = gError?.code || eError?.code;
    signUpError = (
      <div className="error-message">
        <i className="fas fa-exclamation-circle"></i>
        <p>{apiError || getErrorMessage(errorCode)}</p>
      </div>
    );
  }

  const handleGoogleSignIn = () => {
    setApiError(null);
    signInWithGoogle();
  };

  const handleDemoLogin = () => {
    setApiError(null);
    signInWithEmailAndPassword("demo@admin.com", "123456");
  };

  return (
    <>
      <Helmet>
        <title>Login - Welcome Back</title>
        <meta
          name="description"
          content="Discover proven strategies and tools to instantly find high-quality SEO clients. Learn how to attract, pitch, and close deals faster to grow your digital marketing business."
        />
      </Helmet>

      <section className="modern-register-page">
        <div className="register-container">
          <div className="register-card">
            <div className="register-header">
              <div className="close-button">
                <Link to="/" className="close-link">
                  <i className="fas fa-times"></i>
                </Link>
              </div>

              <div className="logo-section">
                <Link to="/">
                  <img
                    src="images/resource/login-page-logo.png"
                    alt="Logo"
                    className="logo"
                  />
                </Link>
              </div>
              <div className="welcome-section">
                <h1>Welcome Back</h1>
                <p>Sign in to continue to your account</p>
              </div>
            </div>

            <div className="register-content">
              {signUpError}

              <div className="demo-login-section">
                <div className="demo-info">
                  <p>Want to test it out?</p>
                  <div className="demo-credentials">
                    <span>Email: <strong>demo@admin.com</strong></span>
                    <span>Pass: <strong>123456</strong></span>
                  </div>
                </div>
                <button
                  onClick={handleDemoLogin}
                  className="demo-signin-btn"
                  disabled={gLoading || eLoading || isProcessing}
                >
                  <i className="fas fa-user-shield"></i>
                  <span>Login as Demo User</span>
                </button>
              </div>

              <div className="divider">
                <span>OR</span>
              </div>

              {/* <div className="google-signin-section">
                <button
                  onClick={handleGoogleSignIn}
                  className="google-signin-btn"
                  disabled={gLoading || eLoading || isProcessing}
                >
                  <div className="google-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20">
                      <path
                        d="M19.8 10.2c0-.6-.1-1.2-.2-1.8H10v3.4h5.5c-.2 1.2-.9 2.3-1.9 3v2.5h3.1c1.8-1.7 2.8-4.1 2.8-7.1z"
                        fill="#4285f4"
                      />
                      <path
                        d="M10 20c2.6 0 4.8-.9 6.4-2.4l-3.1-2.5c-.9.6-2 1-3.3 1-2.5 0-4.7-1.7-5.5-4H1.4v2.5C3 17.4 6.3 20 10 20z"
                        fill="#34a853"
                      />
                      <path
                        d="M4.5 11.9c-.2-.6-.3-1.2-.3-1.9s.1-1.3.3-1.9V5.6H1.4C.5 7.3 0 8.6 0 10s.5 2.7 1.4 4.4l3.1-2.5z"
                        fill="#fbbc05"
                      />
                      <path
                        d="M10 4c1.4 0 2.7.5 3.7 1.4L16.6 2.5C14.8 1 12.6 0 10 0 6.3 0 3 2.6 1.4 5.6l3.1 2.5C5.3 5.7 7.5 4 10 4z"
                        fill="#ea4335"
                      />
                    </svg>
                  </div>
                  <span>Continue with Google</span>
                </button>
              </div> */}

              <div className="features-section">
                <h3>Your Account Benefits?</h3>
                <div className="features-grid">
                  <div className="feature-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Personalized dashboard</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Save your Preferences</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Track your progress</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-check-circle"></i>
                    <span>24/7 Support</span>
                  </div>
                </div>
              </div>
            </div>

            
          </div>
        </div>

        <style jsx>{`
          .demo-login-section {
            margin-bottom: 25px;
            background: rgba(66, 133, 244, 0.05);
            padding: 20px;
            border-radius: 15px;
            border: 1px dashed #4285f4;
          }

          .demo-info {
            text-align: center;
            margin-bottom: 15px;
          }

          .demo-info p {
            font-size: 14px;
            color: #666;
            margin-bottom: 8px;
          }

          .demo-credentials {
            display: flex;
            justify-content: center;
            gap: 15px;
            font-size: 13px;
            color: #444;
          }

          .demo-credentials strong {
            color: #4285f4;
          }

          .demo-signin-btn {
            width: 100%;
            height: 50px;
            background: #4285f4;
            border: none;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .demo-signin-btn:hover {
            background: #3367d6;
            box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);
            transform: translateY(-2px);
          }

          .divider {
            display: flex;
            align-items: center;
            text-align: center;
            margin-bottom: 25px;
            color: #999;
            font-size: 12px;
            font-weight: 600;
          }

          .divider::before,
          .divider::after {
            content: "";
            flex: 1;
            border-bottom: 1px solid #eee;
          }

          .divider span {
            padding: 0 10px;
          }

          .modern-register-page {
            min-height: 100vh;
            background-image: url(/images/shapes/login-page-shape-1.png);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            position: relative;
            overflow: hidden;
          }

          .modern-register-page::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            backdrop-filter: blur(1px);
          }

          .register-container {
            position: relative;
            z-index: 1;
            width: 100%;
            max-width: 500px;
          }

          .register-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .register-header {
            padding: 40px 40px 30px;
            text-align: center;
            position: relative;
          }

          .close-button {
            position: absolute;
            top: 20px;
            right: 20px;
          }

          .close-link {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            color: #666;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .close-link:hover {
            background: rgba(0, 0, 0, 0.2);
            color: #333;
          }

          .logo-section {
            margin-bottom: 30px;
          }

          .logo {
            height: 60px;
            width: auto;
          }

          .welcome-section h1 {
            font-size: 28px;
            font-weight: 700;
            color: #333;
            margin-bottom: 10px;
          }

          .welcome-section p {
            font-size: 16px;
            color: #666;
            margin: 0;
          }

          .register-content {
            padding: 0 40px 30px;
          }

          .error-message {
            background: #fee;
            border: 1px solid #fcc;
            border-radius: 12px;
            padding: 15px;
            margin-bottom: 25px;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .error-message i {
            color: #d32f2f;
            font-size: 18px;
          }

          .error-message p {
            color: #d32f2f;
            margin: 0;
            font-size: 14px;
          }

          .google-signin-section {
            margin-bottom: 30px;
          }

          .google-signin-btn {
            width: 100%;
            height: 56px;
            background: #fff;
            border: 2px solid #e0e0e0;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            font-size: 16px;
            font-weight: 500;
            color: #333;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .google-signin-btn:hover {
            border-color: #4285f4;
            box-shadow: 0 4px 12px rgba(66, 133, 244, 0.2);
            transform: translateY(-2px);
          }

          .google-signin-btn:active {
            transform: translateY(0);
          }

          .google-signin-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
            transform: none;
          }

          .google-icon {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .features-section {
            text-align: center;
          }

          .features-section h3 {
            font-size: 20px;
            font-weight: 600;
            color: #333;
            margin-bottom: 20px;
          }

          .features-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }

          .feature-item {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px;
            background: rgba(102, 126, 234, 0.1);
            border-radius: 8px;
            font-size: 14px;
            color: #555;
          }

          .feature-item i {
            color: #667eea;
            font-size: 16px;
          }

          .register-footer {
            padding: 30px 40px;
            background: rgba(0, 0, 0, 0.02);
            text-align: center;
            border-top: 1px solid rgba(0, 0, 0, 0.05);
          }

          .register-footer p {
            margin: 0 0 15px;
            color: #666;
            font-size: 14px;
          }

          .signin-link {
            color: #667eea;
            text-decoration: none;
            font-weight: 500;
          }

          .signin-link:hover {
            text-decoration: underline;
          }

          .terms-section p {
            font-size: 12px;
            color: #999;
            margin: 0;
          }

          .terms-section a {
            color: #667eea;
            text-decoration: none;
          }

          .terms-section a:hover {
            text-decoration: underline;
          }

          @media (max-width: 768px) {
            .modern-register-page {
              padding: 10px;
            }

            .register-header {
              padding: 30px 30px 20px;
            }

            .register-content {
              padding: 0 30px 20px;
            }

            .register-footer {
              padding: 20px 30px;
            }

            .welcome-section h1 {
              font-size: 24px;
            }

            .features-grid {
              grid-template-columns: 1fr;
            }

            .feature-item {
              justify-content: center;
            }
          }

          @media (max-width: 480px) {
            .register-header {
              padding: 20px 20px 15px;
            }

            .register-content {
              padding: 0 20px 15px;
            }

            .register-footer {
              padding: 15px 20px;
            }

            .welcome-section h1 {
              font-size: 22px;
            }

            .welcome-section p {
              font-size: 14px;
            }

            .google-signin-btn {
              height: 50px;
              font-size: 14px;
            }
          }
        `}</style>
      </section>
    </>
  );
};

export default Login;
